<template>
    <div id="app">
        <meta content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0;" name="viewport" />
        <keep-alive>
            <!-- 需要缓存的视图组件 -->
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <!--v-if="$route.meta.keepAlive"  -->
        <!-- 不需要缓存、的视图组件 -->
        <!-- v-if="!$route.meta.keepAlive" -->
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <van-overlay :show="$store.state.shows">
            <div class="wrapper" @click.stop>
                <van-loading size="3rem" class="JZ" vertical>加载中...</van-loading>
            </div>
        </van-overlay>
        <div class="appShow1" v-show="$store.state.appShow" @click="$store.state.appShow = false">
            <div class="appShow" @click="$store.state.appShow = false">
                <p>相机、存储权限使用说明：</p>
                <p>用于拍照、上传图片等场景</p>
            </div>
        </div>
    </div>
</template>
<script>
import AlertFZ from "./common/js/AlertFZ";
import Util from "./common/js/util";
import axios from "axios";
import myaxios from './axios/api';
export default {
    name: "App",
    data() {
        return {
            openid: "",
        };
    },
    methods: {
        // 创建一个函数来获取IP地址
        getUserIp() {
            return new Promise((resolve) => {
                // 使用第三方API（如ipify）来获取公网IP地址
                const apiUrl = 'https://api.ipify.org?format=json';

                fetch(apiUrl)
                    .then(response => response.json())
                    .then(data => resolve(data.ip))
                    .catch(() => resolve('无法获取IP地址'));
            });
        },
        buyer() {
            var userInfo = JSON.parse(localStorage.getItem('user_xinxi'))
            if (userInfo) {
                myaxios.buyervisits(`buyerId=${userInfo.buyerId}`).then(res => {

                })
            }
        },
        UniAppJSBridgeReady() {
            //定义一个函数，挂载在window上，在uniapp中调用实现消息传递
            window.webReceiveData = (arg) => {
                console.log(JSON.stringify(arg), "测试");
                if (arg.type == 'HQ') {
                    this.$store.state.zxsjFlag = true
                    this.$store.state.readonly=true
                } else if (arg.type == 'TG') {
                    this.$store.state.zxsjFlag = false
                    this.$store.state.appShow = false
                    this.$store.state.readonly=false
                } else if (arg.type == 'SB') {
                    this.$store.state.zxsjFlag = true
                    this.$store.state.appShow = false
                    this.$store.state.readonly=true
                }
            }
        },
    },
    created() {
        this.buyer()
        const local = window.location.href
        if (local.indexOf('openid') != -1) {
            let bb = local.split("&");
            let ee = bb[1].split("=")
            let cc = ee[1].split("#/")
            localStorage.setItem("openId", cc[0]);
        }
        let _this = this;
        var ua = navigator.userAgent.toLowerCase();
        var isWinxin = ua.indexOf("micromessenger") != -1;
        if (isWinxin) {
            let array = [];
            var name, value;
            var str = location.href; //取得整个地址栏
        } else {
            document.onkeydown = function (e) {
                //对整个页面文档监听
                var keyNum = window.event ? e.keyCode : e.which; //获取被按下的键值
                if (keyNum === 37) {
                }
            };
            document.addEventListener("plusready", function () {
                var webview = plus.webview.currentWebview();
                plus.key.addEventListener("backbutton", function () {
                    webview.canBack(function (e) {
                        let _webVIew = localStorage.getItem("webView");
                        if (_webVIew === "false") {
                            _this.$router.go(-1);
                        } else {
                            //webview.close(); //hide,quit
                            //plus.runtime.quit();
                            //首页返回键处理
                            //处理逻辑：1秒内，连续两次按返回键，则退出应用；
                            var first = null;
                            plus.key.addEventListener(
                                "backbutton",
                                function () {
                                    //首次按键，提示‘再按一次退出应用’
                                    if (!first) {
                                        first = new Date().getTime();
                                        _this.$router.go(-1);
                                        AlertFZ.AlertMsg("再按一次退出应用");
                                        setTimeout(function () {
                                            first = null;
                                        }, 1000);
                                    } else {
                                        if (new Date().getTime() - first < 1500) {
                                            plus.runtime.quit();
                                        }
                                    }
                                },
                                false
                            );
                        }
                    });
                });
            });
        }
    },
    mounted() {
        document.addEventListener('UniAppJSBridgeReady', this.UniAppJSBridgeReady)
    }
};
</script>
<style>
html {
    font-size: 2.9vw;
}

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    font-weight: 500;
    font-size: 1.1rem;
}

.wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    height: 6rem;
    width: 6rem;
}

input {
    background: transparent;
    border: none;
    outline: medium;
}

body {
    display: block;
    margin: 0;
    background-color: #f5f5f5;
}

.appShow1 {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background-color: #00000066;
    z-index: 999 !important;
}

.appShow {
    position: fixed;
    top: 2rem;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 99999 !important;
    width: 70vw;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    padding: 1rem 2rem;
    font-size: 1.3rem;

}

.appShow p {
    line-height: 2.5rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue